export const RESULTS = {
	SUCCESS: 'success',
	FAILURE: 'failure',
};
